<template>
  <div class="row">
    <div class="col-lg-12" >
      <div class="row">
        <div class="col-lg-10"></div>
        <div class="col-lg-2">
          <!-- <base-input> -->
            <el-input
              type="search"
              class="mb-3 search-input"
              
              prefix-icon="el-icon-search"
              placeholder="Search Job, Cust..."
              v-model="searchQuery"
              aria-controls="datatables"
            ></el-input>
          <!-- </base-input> -->
        </div>
      </div>
    </div>

    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-12">
          <card class="card-eprf">
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              LIST OF JOBS
            </p>

            <div id="tableku" v-if="this.load == false">
              <el-table
                :data="queriedData"
                style="width: 100%"
                height="550"
                :header-cell-style="{
                  background: 'transparent',
                  //   border: '1px solid #3d3f51',
                  color: 'gray',
                  //   borderBottom: '0.5px solid #3d3f51',
                }"
                :cell-style="{
                  color: 'black',
                  //   border: '1px solid #3d3f51',
                  //   borderBottom: '0.5px solid #3d3f51',
                }"
              >
                <el-table-column
                  v-for="column in jobno"
                  :key="column.label"
                  :prop="column.prop"
                  :label="column.label"
                  align="center"
                  :min-width="200"
                >
                </el-table-column>
                <el-table-column
                  :min-width="200"
                  sortable
                  align="center"
                  label="DATE CREATED"
                >
              </el-table-column>
                <el-table-column
                  v-for="column in joblist"
                  :key="column.label"
                  :prop="column.prop"
                  :label="column.label"
                  align="center"
                  :min-width="200"
                >
                </el-table-column>
              </el-table>
            </div>
          </card>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <!-- <base-input> -->
            <el-select
              v-model="pagination.perPage"
              placeholder="Per page"
              style="
                /* background-color: #358CCB; */
                /* color: white; */
                border-radius: 10px;
              "
            >
              <el-option
                class="select-primary"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <!-- </base-input> -->
            <!-- <div class>
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div> -->
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            ></base-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Alert,
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
} from "element-ui";
import swal from "sweetalert2";
import { Circle8 } from "vue-loading-spinner";
import util from "../../../util/util";
import Card from "../../../components/Cards/Card.vue";
import {
  Modal,
  ImageUpload,
  BasePagination,
  BaseSwitch,
} from "../../../../src/components";
import moment from "moment";

export default {
  name: "AuthoritiesJob",

  components: {
    Card,
    Modal,
    ImageUpload,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseSwitch,
    Circle8,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  data() {
    return {
      selectedFileName: "",
      allfilename: [],
      showPassword: false,
      showPassword1: false,
      showPassword2: false,
      showPassword3: false,

      load: false,

      jobno: [
        {
          prop: "job-no",
          label: "REFERENCE NO",
        },
      ],
      joblist: [
        {
          prop: "job-no",
          label: "COLLECTION DATE",
        },
        {
          prop: "job-no",
          label: "JOB DURATION",
        },
        {
          prop: "job-no",
          label: "APPOINTMENT",
        },
        {
          prop: "job-no",
          label: "PTW",
        },
        {
          prop: "job-no",
          label: "CN",
        },
        {
          prop: "job-no",
          label: "",
        },
      ],

      //data from user
      agencyname: "",
      phoneno: "",
      supportdoc: "",

      fullname: "",
      password: "",
      confirmpassword: "",
      phoneno1: "",
      email: "",
      picdepartment: "",

      fullname2: "",
      password2: "",
      confirmpassword2: "",
      phoneno2: "",
      email2: "",
      picdepartment2: "",

      img: null,
      imgdescription: "",
      image: "",
      imagebase64: "",
      images: {
        regular: null,
      },

      addPIC: false,

      modals: {
        successModal: false,
        failedModal: false,
      },

      selects: {
        date: "",
      },

      swdisposed: [
        { value: "1", label1: "SW 101", label2: "300,000 MT" },
        { value: "2", label1: "SW 101", label2: "270,000 MT" },
        { value: "3", label1: "SW 101", label2: "300,000 MT" },
        { value: "4", label1: "SW 101", label2: "300,000 MT" },
        { value: "5", label1: "SW 101", label2: "300,000 MT" },
        { value: "6", label1: "SW 101", label2: "300,000 MT" },
        { value: "7", label1: "SW 101", label2: "300,000 MT" },
        { value: "8", label1: "SW 101", label2: "300,000 MT" },
        { value: "9", label1: "SW 101", label2: "300,000 MT" },
        { value: "10", label1: "SW 101", label2: "50,000 MT" },
      ],

      searchedData: [],
      fuseSearch: null,
      currentRow: "",
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [10, 30, 50],
        total: 0,
      },
    };
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    toggleShow1() {
      this.showPassword1 = !this.showPassword1;
    },

    toggleShow2() {
      this.showPassword2 = !this.showPassword2;
    },
    toggleShow3() {
      this.showPassword3 = !this.showPassword3;
    },

    addCard() {
      this.addPIC = true;
    },
    cancelAddCard() {
      this.addPIC = false;
    },
    successModal() {
      this.modals.successModal = true;
    },
    failedModal() {
      this.modals.failedModal = true;
    },
    closeFailedModal() {
      this.modals.failedModal = false;
    },
    getLogin() {
      this.$router.push("/Vendor/Job");
      console.log("hoi");
    },
    onFileChange(event) {
      const input = event.target;
      if (input.files.length > 0) {
        for (let i = 0; i < input.files.length; i++) {
          this.selectedFileName = input.files[i].name;
          this.allfilename.push(this.selectedFileName);
        }
      } else {
        this.selectedFileName = "";
      }
    },
    removeFile(indexToRemove) {
      if (indexToRemove >= 0 && indexToRemove < this.allfilename.length) {
        this.allfilename.splice(indexToRemove, 1);
      }
      this.$emit("change", null);
    },
  },
  created() {},
  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },

    // queriedData() {
    //   let result = this.tableDatas;
    //   if (this.searchedData.length > 0) {
    //     result = this.searchedData;
    //   }
    //   return result.slice(this.from, this.to);
    // },
    // to() {
    //   let highBound = this.from + this.pagination.perPage;
    //   if (this.total < highBound) {
    //     highBound = this.total;
    //   }
    //   return highBound;
    // },
    // from() {
    //   return this.pagination.perPage * (this.pagination.currentPage - 1);
    // },
    // total() {
    //   return this.searchedData.length > 0
    //     ? this.searchedData.length
    //     : this.tableDatas.length;
    // },
  },
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
.custom-input {
  padding: 5px 10px 5px 10px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
  outline: none;
  font-size: 16px;
  width: 100%;
}

p {
  margin-top: 10px;
  font-size: 14px;
  color: #333;
}
.custom-button {
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
}
</style>
